var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage030(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94814 37.6135L21.8624 25.6641C22.6376 24.9467 23.0253 24.588 23.4723 24.4536C23.8655 24.3354 24.289 24.3354 24.6822 24.4536C25.1292 24.588 25.5169 24.9467 26.2922 25.6641L39.1203 37.5338M27.9927 27.2376L33.6087 22.0412C34.384 21.3238 34.7716 20.9651 35.2186 20.8307C35.6118 20.7125 36.0354 20.7125 36.4286 20.8307C36.8756 20.9651 37.2632 21.3238 38.0385 22.0412L43.6545 27.2376M20.1618 16.3688C20.1618 18.3697 18.4088 19.9917 16.2464 19.9917C14.0839 19.9917 12.3309 18.3697 12.3309 16.3688C12.3309 14.3679 14.0839 12.7459 16.2464 12.7459C18.4088 12.7459 20.1618 14.3679 20.1618 16.3688ZM13.8971 38.1064H34.2574C37.5467 38.1064 39.1914 38.1064 40.4477 37.5141C41.5528 36.993 42.4513 36.1617 43.0144 35.1391C43.6545 33.9767 43.6545 32.4549 43.6545 29.4113V14.195C43.6545 11.1515 43.6545 9.62971 43.0144 8.46723C42.4513 7.44468 41.5528 6.61333 40.4477 6.09231C39.1914 5.5 37.5467 5.5 34.2574 5.5H13.8971C10.6078 5.5 8.96315 5.5 7.70681 6.09231C6.6017 6.61333 5.70322 7.44468 5.14014 8.46723C4.5 9.62971 4.5 11.1515 4.5 14.195V29.4113C4.5 32.4549 4.5 33.9767 5.14014 35.1391C5.70322 36.1617 6.6017 36.993 7.70681 37.5141C8.96315 38.1064 10.6078 38.1064 13.8971 38.1064Z",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage030);
export default __webpack_public_path__ + "static/media/image-030.3f3507455fbb5b9dce93c4e862f3b77f.svg";
export { ForwardRef as ReactComponent };